import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";
import { SESSION_QUERY_KEY } from "./CheckSessionHook";

export type SuccessorConnectionPayload = {
  clientId: number | null;
  successorUuid: string;
};

export const useSuccessorConnection = (
  options?: UseMutationOptions<any, Error, SuccessorConnectionPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["successor-connection"],
    mutationFn: async (payload: SuccessorConnectionPayload) => {
      return axiosInstance
        .post("/admin/successors/connection", payload)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Łączę sukcesora z klientem...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "successor-connection",
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: data.message,
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "successor-connection",
      });
      queryClient.invalidateQueries({ queryKey: ["successors-list"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY });
      Toast({
        message: "Błąd podczas łączenia sukcesora z klientem.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "successor-connection",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useSuccessorConnection;
